import React from 'react';
import { Box, Typography } from '@mui/material';

export const WorkspaceHeader: React.FC = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        mb: 4,
        mt: 3,
        px: 1
      }}
    >
      <Typography 
        variant="h4" 
        sx={{ 
          fontSize: { xs: '1.5rem', sm: '2rem' },
          letterSpacing: '-0.02em'
        }}
      >
        Product Roadmap
      </Typography>
    </Box>
  );
};